import "../App.css";
import { Link } from "react-router-dom";

function Navbar(props) {
  const collapseNavbar = () => {
    const navbarToggler = document.getElementById("navbarNav");
    if (navbarToggler && navbarToggler.classList.contains("show")) {
      navbarToggler.classList.remove("show");
    }
  };
  return (
    <nav className="navbar navbar-expand-md navbar-light m-3">
      <div className="container-fluid">
        <Link to="/">
          <p className="navbar-brand montserratFont">tailored stories</p>
        </Link>

        {/* Toggler button for mobile view */}
        <button
          className="navbar-toggler navbar-toggler-small"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible content */}
        <div className="collapse navbar-collapse text-center" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {/* Dropdown for "Occasion" */}
            {Array.isArray(props.cartItems) && props.cartItems.length > 0 && (
              <li className="nav-item d-flex">
                <Link
                  onClick={collapseNavbar}
                  to="/cart"
                  className="nav-link bg-primary-color px-2 m-md-2 rounded-5 text-white desktopCartIcon"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    className="cartIcon"
                  >
                    <path d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
                  </svg>
                </Link>
              </li>
            )}

            <li className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle"
                id="occasionDropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Occasion
              </button>
              <div
                className="dropdown-menu rounded-0"
                aria-labelledby="occasionDropdown"
              >
                <Link onClick={collapseNavbar} to="/" className="dropdown-item">
                  weddings
                </Link>
                <Link
                  onClick={collapseNavbar}
                  to="/events"
                  className="dropdown-item"
                >
                  events
                </Link>
                <Link
                  onClick={collapseNavbar}
                  to="/portraits"
                  className="dropdown-item"
                >
                  portraits
                </Link>
              </div>
            </li>

            {/* Other navbar items */}
            <li className="nav-item">
              <Link
                onClick={collapseNavbar}
                to="/catalogue"
                className="nav-link"
              >
                Catalogue
              </Link>
            </li>
            <li className="nav-item">
              <Link onClick={collapseNavbar} to="/prints" className="nav-link">
                Prints
              </Link>
            </li>
            <li className="nav-item">
              <Link onClick={collapseNavbar} to="/zine" className="nav-link">
                Zine
              </Link>
            </li>

            <li className="nav-item">
              <Link onClick={collapseNavbar} to="/contact" className="nav-link">
                Contact
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link to="/cart" className="nav-link">
                Cart
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
      {Array.isArray(props.cartItems) && props.cartItems.length > 0 && (
        <Link
          to="/cart"
          className="container-fluid nav-link-cart bg-primary-color px-2 py-0 m-md-2 rounded-5 text-white d-md-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            className="cartIcon"
          >
            <path d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
          </svg>
        </Link>
      )}
    </nav>
  );
}

export default Navbar;
